import { RowProps } from "../../../components";

export const SystemMessageSearchFormKey = {
  country: "country",
} as const;

export interface SystemMessageSearchFormType {
  country: string;
}

export const SystemMessageSearchFormDefaultValues = {
  [SystemMessageSearchFormKey.country]: "",
};

export const SystemMessageSearchResultKey = {
  messageIdFormat: "messageIdFormat",
  messageTitle: "messageTitle",
  messageDescription: "messageDescription",
  countryName: "countryName",
  languageName: "languageName",
  persistence: "persistence",
  fromDate: "fromDate",
  toDate: "toDate",
} as const;

export interface UserCountry {
  countryIdentifier: string;
  masterCountryName: string;
  localeName: string;
  localeDescription?: string;
}

export interface MessageResponse extends RowProps {
  id: string;
  messageId: string;
  messageTitle: string;
  messageDescription: string;
  fromDate: string;
  toDate: string;
  countryCodes: string[];
  languageCode: string;
  isPersistent: boolean;
  timezone: string;
}

export interface ViewMessageResponse {
  id: string;
  messageId?: string;
  messageTitle?: string;
  messageDescription?: string;
  fromDate?: string;
  toDate?: string;
  countryCodes?: string;
  languageCode?: string;
  isPersistent?: boolean;
  timezone?: string;
  linkName?: string;
  linkUrl?: string;
  linkPosition?: string;
  messageIdFormat?: string;
  countryName?: string;
  languageName?: string;
}
